export default __webpack_public_path__ + "static/media/logo-1.94ee5fca.png";